export function rolesOptions (state) {
  let rolesOptions = state.roles.filter(res => res.status === "Enabled" ).map(res => {
    res = {...res, label: res.nameTh, value: res.id};
    return res
  })
  return rolesOptions || []
}

export function permissionsSubMenu (state) {
  let permissionsSubMenu = state.subMenus.map(res => {
    res = {...res, visible: false, create: false, edit: false, delete: false };
    return res
  })
  return permissionsSubMenu || []
}
